/* KartComms homepage motion.
   html.kc-motion is set by the inline guard ONLY when motion is allowed and IntersectionObserver exists.
   Without it, all content is visible by default (reduced-motion / no-JS / headless never ship blank).
   A failsafe timer in the inline guard reveals everything if these observers never fire. */
(function () {
  var h = document.documentElement;
  if (!h.classList.contains('kc-motion')) return;

  function observe(els, opts) {
    if (!els || !els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kc-in'); io.unobserve(e.target); }
      });
    }, opts || { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  // How It Works: draw the connector + pop the nodes in sequence.
  observe(document.querySelectorAll('[data-flow]'), { threshold: 0.35 });

  // Product selector: sibling-stagger the cards in.
  var grid = document.querySelector('.kc-shop__grid');
  if (grid) observe([grid], { threshold: 0.12 });
})();
